






























/* 
  getParam 获取统计页面参数
  getMarkHistoryStatistics 统计
*/
import { Vue, Component } from "vue-property-decorator";
import echarts from "echarts";
import {
  getParam,
  getMarkHistoryStatistics
} from "../../../api/markingHistoryStatistics";
//引入导入、导出、下载的处理函数
import importAndExportMixin from "../../../mixins/importAndExport";

//自定义对象接口
interface CustomData {
  [propName: string]: any;
}

@Component({
  name: "markingHistoryStatistics",
  mixins: [importAndExportMixin]
})
export default class extends Vue {
  private projectId: string = ""; //考试定义（项目id）
  private statisticalType: number = 0; //统计类型(默认：各年度各类考试的评卷教师数量)
  private statisticalTypeArray: CustomData[] = [
    { name: "数量", label: "请选择统计类型", id: 0, data: {} },
    { name: "科目", label: "各个科目的评卷教师数量", id: 1, data: {} },
    { name: "年龄", label: "评卷教师年龄分布图", id: 2, data: {} },
    { name: "性别", label: "评卷教师性别分布图", id: 3, data: {} },
    { name: "职称", label: "评卷教师职称分布图", id: 4, data: {} },
    { name: "教龄", label: "评卷教师教龄分布图", id: 5, data: {} },
    { name: "学校", label: "优秀教师单位分布", id: 6, data: {} },
    { name: "出勤率", label: "评卷教师出勤率统计", id: 7, data: {} },
    { name: "角色", label: "评卷教师角色统计", id: 8, data: {} }
  ]; //统计类型数组
  private colors: string[] = [
    "#3ACAE8",
    "#FE8EAE",
    "#CEA0FE",
    "#7DDAB5",
    "#E4D85F",
    "#F8A655",
    "#92CEC8",
    "#FECE82",
    "#13C7E2"
  ]; //color数组
  //页面参数
  private projects: object[] = []; //项目数组
  private showChart = true

  created() {
    //获取页面参数
    this.getParams();
  }

  mounted() {
    //获取数据，绘制图表
    this.getData();
  }

  //获取页面参数
  private async getParams() {
    try {
      let res = await getParam();
      this.projects = res.data;
    } catch (error) {
      // this.$message.error(error || "获取数据失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  //获取页面数据
  private async getData() {
    if (this.statisticalType !== 0 && !this.projectId) {
      this.$message.warning("请选择考试项目！");
      return;
    }
    let params = {
      projectId: this.projectId, //考试定义id/项目id(统计类型是0的时候不用传项目id)
      type: this.statisticalType //统计类型: 0:各年度各类考试的评卷教师数量 1:科目统计 2:年龄统计 3:性别统计 4:职称统计 5:教龄统计 6:学校统计
    };
    try {
      let res = await getMarkHistoryStatistics(params);
      //数据处理成图表需要的格式
      switch (this.statisticalType) {
        //各年度各类考试的评卷教师数量
        case 0:
          //获取生成的柱子数量
          this.statisticalTypeArray[0].data.bars = res.data.annualExamMarkTchStatisticVo.years.map(
            i => {
              return {
                type: "bar",
                barWidth: "25",
                itemStyle: {
                  // 图形的形状
                  normal: {
                    label: {
                      show: true,
                      position: "top",
                      color: "#333"
                    }
                  }
                }
              };
            }
          );
          //获取年份
          this.statisticalTypeArray[0].data.years =
            res.data.annualExamMarkTchStatisticVo.years;
          this.statisticalTypeArray[0].data.years.unshift("quantity");
          //获取数据
          this.statisticalTypeArray[0].data.statisticValue = res.data.annualExamMarkTchStatisticVo.statisticValue.map(
            i => {
              return { quantity: i.name, ...i.value };
            }
          );
          break;
        //其他饼图
        default:
          this.statisticalTypeArray[this.statisticalType].data =
            res.data.markHistoryStatisticsVos;
      }
      //绘制图表
      this.drawChart();
    } catch (error) {
      // this.$message.error(error || "获取数据失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  //绘图
  private drawChart() {
    //绘图
    let myChart = echarts.init(this.$refs.chart as HTMLCanvasElement);
    myChart.showLoading();
    let option = {};
    //清空图表
    myChart.clear();
    //根据统计类型配置
    if (this.statisticalType === 0) {
      option = this.setOption0();
    } else {
      option = this.setOptionPie();
    }
    myChart.hideLoading();
    myChart.setOption(option);
  }

  //statisticalType为0时的配置（0:各年度各类考试的评卷教师数量）
  private setOption0() {
    return {
      title: {
        text: "各个年度各类考试的评卷教师数量",
        left: "center"
      },
      legend: {
        right: 20
      },
      color: this.colors,
      tooltip: {}, //悬浮文字说明
      grid: {
        top: 110
      },
      dataset: {
        dimensions: this.statisticalTypeArray[0].data.years, // ["quantity", 2019, 2018, 2017, 2016, 2015]
        source: this.statisticalTypeArray[0].data.statisticValue //格式：[{quantity: "会考", 2015: 4, 2016: 3, 2017: 8, 2018: 4, 2019: 9},...]
      },
      xAxis: { type: "category" },
      yAxis: {},
      series: this.statisticalTypeArray[0].data.bars //格式：[{type: "bar"},...]
    };
  }

  //statisticalType为非0时的配置（饼图）
  private setOptionPie() {
    return {
      title: {
        text: this.statisticalTypeArray[this.statisticalType].label,
        left: "center"
      },
      grid: {
        top: 110
      },
      tooltip: {
        trigger: "item",
        formatter: "{b} : {c} ({d}%)"
      },
      calculable: true,
      series: [
        {
          name: this.statisticalTypeArray[this.statisticalType].name,
          type: "pie",
          radius: ["32%", "57%"],
          center: ["50%", "45%"],
          hoverOffset: 25,
          labelLine: {
            length: 40,
            length2: 70
          },
          itemStyle: {
            color: (params: any) => {
              //饼图的颜色
              let colorList = this.colors;
              return colorList[params.dataIndex];
            }
          },
          data: this.statisticalTypeArray[this.statisticalType].data
        }
      ]
    };
  }

  //导出
  private exportHandle() {
    if (this.statisticalType !== 0 && !this.projectId) {
      this.$message.warning("请选择考试项目！");
      return;
    }
    let params = {
      projectId: this.projectId, //考试定义id/项目id(统计类型是0的时候不用传项目id)
      type: this.statisticalType //统计类型: 0:各年度各类考试的评卷教师数量 1:科目统计 2:年龄统计 3:性别统计 4:职称统计 5:教龄统计 6:学校统计
    };
    (this as any).downloadHandle(
      "exportMarkHistoryStatistics",
      "评卷历史统计.docx",
      params
    );
  }
}
